import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import { UtilsService } from "@foo/foo-framework";



@Injectable({
  providedIn: 'root'
})
export class UploadService {
  prefix = 'api/';
  protected http = inject(HttpClient);
  protected utils = inject(UtilsService);
  
  constructor() { }

  upload(file: File, uploadPath:string, url:string, params:any = null): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();



    formData.append('file', file);
    if (url) formData.append('url', url);
    if(params) {
      let keys = Object.keys(params);

      if(keys.length) {
        keys.forEach(element => {
          if (element === 'params[analytics]') params[element] = JSON.stringify(params[element]);
          formData.append(element, params[element]);
        });
      }
    }

    const timeZone = this.utils.getTimeZone();
    const headers = new HttpHeaders().set('X-USER-TIMEZONE', timeZone)
      .set('update-loading', 'false')

    const req = new HttpRequest('POST', this.prefix + uploadPath, formData, {
      headers,
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }
}
